/** @format */

import { Header } from "./Header";
import { Main } from "./Main";

export default function App() {
  return (
    <div>
      <Header></Header>
      <Main></Main>
    </div>
  );
}
